export interface ICustomizationImageTagSchema {
    _id: string;
    brandId: string;
    tags: ICustomizationImageTag[];
}

export enum TagFilterType {
    EQ = "$eq",
    GTE = "$gte",
    GT = "$gt",
    LTE = "$lte",
    LT = "$lt",
    CONTAINS = "$contains",
    CONTAINS_OR_NULL = "$containsornull",
    IN_ARRAY = "$inarray",
    ID_IN = "$idin",
    IN_ARRAY_OR_NULL = "$inarrayornull",
}

export enum TagDataTypes {
    BOOLEAN = "BOOLEAN",
    STRING = "STRING",
    STRING_ARRAY = "STRING_ARRAY",
    NUMBER = "NUMBER",
}

export enum FetchSourceTypes {
    PRODUCT = "PRODUCT",
    PRODUCT_FDM = "PRODUCT_FDM",
    CUSTOMIZATION_ATTRIBUTE = "CUSTOMIZATION_ATTRIBUTE",
    CUSTOMIZATION_SELECTION = "CUSTOMIZATION_SELECTION",
    COMPANY = "COMPANY",
    COMPANY_FDM = "COMPANY_FDM",
}

export interface IConstantSource {
    string?: string;
    number?: number;
    boolean?: boolean;
}

export interface IFetchSource {
    type: FetchSourceTypes;
    keypath: string;
}

export interface IImageTagFilter {
    constantSource?: IConstantSource;
    fetchSource?: IFetchSource;
    isNot: boolean;
    type: TagFilterType;
}

export interface ICustomizationImageTag {
    _id: string;
    name: string;
    externalId: string;
    isVisible: boolean;
    isSearchable: boolean;
    isApiFormattable: boolean;
    isArchived: boolean;
    type: TagDataTypes;
    filter?: IImageTagFilter;
}
